import { Check, cn } from "@monbits/ui";
import type * as React from "react";

interface Props {
	title: string;
	description: string;
	isActive: boolean;
	rightIcon?: React.ReactNode;
}

const CustomCard: React.FC<Props> = ({
	title,
	description,
	isActive,
	rightIcon,
}: Props) => {
	return (
		<div
			className={cn(
				"flex items-center gap-4 p-4 rounded-lg border bg-card transition-colors hover:bg-accent/50",
			)}
		>
			{/* Active indicator */}
			<div className="flex-shrink-0 w-5">
				{isActive && <Check className="h-5 w-5 text-primary" />}
			</div>

			{/* Content */}
			<div className="flex-1 min-w-0">
				<h3 className="font-semibold text-base">{title}</h3>
				<p className="text-sm text-muted-foreground">{description}</p>
			</div>

			{/* Actions */}
			{rightIcon && (
				<div className="flex-shrink-0 flex items-center gap-1">{rightIcon}</div>
			)}
		</div>
	);
};

export default CustomCard;
